export const theme = {
  color: {
    blue: "#3167eb",
    blueDark: "#0b4ce9",
    indigo: "#6610f2",
    purple: "#6f42c1",
    pink: "#e83e8c",
    red: "#fa3434",
    orange: "#ff9017",
    yellow: "#ffc107",
    green: "#00b517",
    teal: "#20c997",
    cyan: "#17a2b8",
    white: "#fff",
    gray: "#545454",
    grayDark: "#343a40",
    grayLight: "#969696",
    primary: "#3167eb",
    secondary: "#545454",
    success: "#00b517",
    info: "#17a2b8",
    warning: "#ff9017",
    danger: "#fa3434",
    light: "#ced4da",
    dark: "#343a40",
    primaryLight: "#5f89f0",
    primaryDark: "#0b4ce9",
  },
  wrapperWidth: "63%",
};
